import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import ShortLogoIcon from "./ui-icons/header/ShortLogoIcon";

const Loading = () => {
  return (
    <FlexRow className="flex flex-row place-content-center py-3">
      <FlexCol className="flex flex-col animate-spin">
        <ShortLogoIcon />
      </FlexCol>
    </FlexRow>
  );
};

export default Loading;
